<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { HTMLInputAttributes } from 'svelte/elements'

  let {
    value = $bindable(),
    start,
    end,
    ...rest
  }: HTMLInputAttributes & {
    value?: string | number
    start?: Snippet
    end?: Snippet
  } = $props()
</script>

<div class="input">
  {#if start}
    <span class="input-start">{@render start()}</span>
  {/if}
  <input class="input-field" bind:value {...rest} />
  {#if end}
    <span class="input-end">{@render end()}</span>
  {/if}
</div>

<style>
  .input {
    display: flex;
    align-items: center;
    gap: var(--space-5);
    border: var(--border-style-1);
    border-radius: var(--radius-2);
    padding: var(--space-4) var(--space-6);
    box-shadow: var(--box-shadow-1);
    transition: box-shadow var(--transition-fast), border-color var(--transition-fast);

    &:focus-within {
      border: var(--border-style-2);
      box-shadow: var(--box-shadow-2), var(--box-shadow-1);
    }
  }

  .input-start,
  .input-end {
    display: flex;
    align-items: center;
    flex: none;
  }

  .input-field {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font: inherit;
    font-size: var(--font-size-5);
    color: var(--color-text);
    min-width: 0;
  }
</style>
